import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, ElementRef, ViewChild, HostListener, ViewChildren, QueryList } from '@angular/core';
import { MainService } from '../../services/main.service';

declare const window;

@Component({
  selector: 'app-skills2',
  templateUrl: './skills2.component.html',
  styleUrls: ['./skills2.component.scss']
})
export class Skills2Component implements OnInit, AfterViewChecked {

  @ViewChild('d') d: ElementRef;
  @ViewChildren('dm') dm: QueryList<any>;
  @ViewChildren('dm', { read: ElementRef }) dme: QueryList<ElementRef>;
  skills;
  skillDetailId;
  skillDetail;
  skillDetailContainer: boolean;
  currentSkill;

  constructor(private mainService: MainService,
    private cd: ChangeDetectorRef) {
    this.skillDetailId = 'ready';
    this.skills = [
      {
        id: 'ready',
        cover: {
          icon: 'assets/icons/developing.svg',
          infosIcon: 'assets/icons/infos/developing.svg',
          title: 'skills.ready.card.description'
        },
        detail: {
          title: 'skills.ready.card.description',
          items: [
            {
              icon: 'assets/icons/software_develop.svg',
              infosIcon: 'assets/icons/infos/software_develop.svg',
              title: 'skills.ready.detail.development.title',
              description: 'skills.ready.detail.development.description'
            },
            {
              icon: 'assets/icons/software_factory.svg',
              infosIcon: 'assets/icons/infos/software_factory.svg',
              title: 'skills.ready.detail.factory.title',
              description: 'skills.ready.detail.factory.description'
            },
            {
              icon: 'assets/icons/project_methodology.svg',
              infosIcon: 'assets/icons/infos/project_methodology.svg',
              title: 'skills.ready.detail.agile.title',
              description: 'skills.ready.detail.agile.description'
            },
            {
              icon: 'assets/icons/factory_deployment.svg',
              infosIcon: 'assets/icons/infos/factory_deployment.svg',
              title: 'skills.ready.detail.deployment.title',
              description: 'skills.ready.detail.deployment.description'
            },
            {
              icon: 'assets/icons/project_coaching.svg',
              infosIcon: 'assets/icons/infos/project_coaching.svg',
              title: 'skills.ready.detail.coaching.title',
              description: 'skills.ready.detail.coaching.description'
            }
          ]
        },
        show: false
      },
      {
        id: 'deploying',
        cover: {
          icon: 'assets/icons/deploying.svg',
          infosIcon: 'assets/icons/infos/deploying.svg',
          title: 'skills.deploying.card.description'
        },
        detail: {
          title: 'skills.deploying.card.description',
          items: [
            {
              icon: 'assets/icons/wifi.svg',
              infosIcon: 'assets/icons/infos/wifi.svg',
              title: 'skills.deploying.detail.wifi.title',
              description: 'skills.deploying.detail.wifi.description'
            },
            {
              icon: 'assets/icons/renting_services.svg',
              infosIcon: 'assets/icons/infos/renting_services.svg',
              title: 'skills.deploying.detail.renting.title',
              description: 'skills.deploying.detail.renting.description'
            },
            {
              icon: 'assets/icons/ready.svg',
              infosIcon: 'assets/icons/infos/ready.svg',
              title: 'skills.deploying.detail.ready.title',
              description: 'skills.deploying.detail.ready.description'
            },
            {
              icon: 'assets/icons/maintenance_repair.svg',
              infosIcon: 'assets/icons/infos/maintenance_repair.svg',
              title: 'skills.deploying.detail.maintenance.title',
              description: 'skills.deploying.detail.maintenance.description'
            },
            {
              icon: 'assets/icons/help_desk.svg',
              infosIcon: 'assets/icons/infos/help_desk.svg',
              title: 'skills.deploying.detail.help.title',
              description: 'skills.deploying.detail.help.description'
            },
          ]
        },
        show: false
      },
      {
        id: 'cloudbase',
        cover: {
          icon: 'assets/icons/hosting.svg',
          infosIcon: 'assets/icons/infos/hosting.svg',
          title: 'skills.cloud.card.description'
        },
        detail: {
          title: 'skills.cloud.card.description',
          items: [
            {
              icon: 'assets/icons/on_demand_performances.svg',
              infosIcon: 'assets/icons/infos/on_demand_performances.svg',
              title: 'skills.cloud.detail.ondemand.title',
              description: 'skills.cloud.detail.ondemand.description'
            },
            {
              icon: 'assets/icons/reliability.svg',
              infosIcon: 'assets/icons/infos/reliability.svg',
              title: 'skills.cloud.detail.reliability.title',
              description: 'skills.cloud.detail.reliability.description'
            },
            {
              icon: 'assets/icons/speed_up.svg',
              infosIcon: 'assets/icons/infos/speed_up.svg',
              title: 'skills.cloud.detail.speed.title',
              description: 'skills.cloud.detail.speed.description'
            },
            {
              icon: 'assets/icons/proximity.svg',
              infosIcon: 'assets/icons/infos/proximity.svg',
              title: 'skills.cloud.detail.proximity.title',
              description: 'skills.cloud.detail.proximity.description'
            }
          ]
        },
        show: false
      }
    ];
  }

  ngOnInit() {
    this.skillDetailContainer = false;
  }

  // Recibe skill pulsado, show a true y los demas a false
  public receiveSkill(skill) {
    this.skills.forEach(
      (item) => {
        if (item.id === skill.id) {
          this.currentSkill = item;
          this.currentSkill.show = !this.currentSkill.show;
          this.cd.detectChanges();
          this.scrollToDetail(skill);
        } else {
          item.show = false;
        }
      });
  }

  private getDistanceToDocumentTop(element, mode) {
    let yPosition = 0;
    if (!mode) {
      while (element) {
        yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
        element = element.offsetParent;
      }
      return yPosition;
    } else {
      while (element) {
        yPosition += (element.offsetTop + element.clientTop);
        element = element.offsetParent;
      }
      return yPosition;
    }
  }

  public getMarkPosition(id) {
    switch (id) {
      case 'ready':
        return 'l-mark';
      case 'deploying':
        return 'c-mark';
      case 'cloudbase':
        return 'r-mark';
    }
  }
  private scrollToDetail(skill) {
    if ((window.innerWidth > 991) && this.currentSkill['show']) {
      window.scrollTo(0, this.getDistanceToDocumentTop(this.d.nativeElement, false));
    } else if ((window.innerWidth <= 991) && this.currentSkill['show']) {
      let skillIndex = 0;
      const dmArray = this.dm.toArray();
      for ( let i = 0; i < dmArray.length; i++) {
        if (skill['id'] === this.dm.toArray()[i]['skill']['id']) {
          skillIndex = i;
        }
      }
      this.getDistanceToDocumentTop(this.dme.toArray()[skillIndex].nativeElement, true);
      window.scrollTo(0, this.getDistanceToDocumentTop(this.dme.toArray()[skillIndex].nativeElement, true));
    }
  }
  ngAfterViewChecked() {
    if (window.innerWidth > 991) {
      this.skillDetailContainer = true;
    } else {
      this.skillDetailContainer = false;
    }
    this.cd.detectChanges();
  }
}
